import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { RequestTypes } from '../../../models/enums/request-types.enum';
import { HttpService } from './../http.service';
import {HttpConfiguration} from '../../../app.http.config';

@Injectable()
export class CardHttpService extends HttpService {
    constructor(httpConfig: HttpConfiguration, http: HttpClient) {
        super('api/card/', RequestTypes.InternalApi, httpConfig, http);
    }

    public activationCardForAuthorizedUser(item: any): Observable<any> {
        return this.post('activationCardForAuthorizedUser', item).pipe();
    }

    public activationCardForRegisteredUser(item: any): Observable<any> {
        return this.post('activationCardForRegisteredUser', item).pipe();
    }

    public activationCardForUnRegisteredUser(item: any): Observable<any> {
        return this.post('activationCardForUnRegisteredUser', item).pipe();
    }

    public postCardActivate(item: any): Observable<any> {
        return this.post('postCardActivate', item).pipe();
    }

    public checkActivationCardHasDevice(item: any): Observable<any> {
        return this.post('checkActivationCardHasDevice', item).pipe();
    }
}



// WEBPACK FOOTER //
// ./src/app/core/http/internal/card.http.service.ts